import React from "react";

const SelectCustom = ({
  label,
  handleChange,
  name,
  value,
  children,
  minText,
  id,
  className,
}) => {
  return (
    <label className={`field-item ${className}`}>
      <span>{label}</span>
      <select name={name} onChange={handleChange} value={value} id={id}>
        {children}
      </select>
      <i>{minText}</i>
    </label>
  );
};

export default SelectCustom;
